import { render, staticRenderFns } from "./Part-1.vue?vue&type=template&id=b50dd44e&"
import script from "./Part-1.vue?vue&type=script&lang=js&"
export * from "./Part-1.vue?vue&type=script&lang=js&"
import style0 from "./Part-1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports